import { render, staticRenderFns } from "./compSearchBox.vue?vue&type=template&id=5b6066ec&"
import script from "./compSearchBox.vue?vue&type=script&lang=js&"
export * from "./compSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6066ec')) {
      api.createRecord('5b6066ec', component.options)
    } else {
      api.reload('5b6066ec', component.options)
    }
    module.hot.accept("./compSearchBox.vue?vue&type=template&id=5b6066ec&", function () {
      api.rerender('5b6066ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compSearchBox.vue"
export default component.exports